import { Flex, GridItem, GridItemProps, Text } from "@chakra-ui/react";
import React from "react";
import { TranslationsId, useVocabIntl } from "../../../hooks/useVocabTranslation";

interface StatBoxProps extends GridItemProps {
  value: number,
  translationId: TranslationsId,
  translationValues?: Record<string, string>,
}

export function StatBox({ value, translationId, translationValues, ...others }: StatBoxProps) {
  const { APFormattedMessage } = useVocabIntl()
  return (
    <GridItem textAlign={"center"} backgroundColor={"lightGray.500"}
              padding={["0.5rem", null, "1rem"]} borderRadius={"1rem"} {...others}>
      <Flex flexDirection={"column"} width={"100%"} alignItems={"center"}>
        <Text fontSize={["xl", "2xl", "4xl"]} lineHeight={[1, 1.1, 1.2]} fontWeight={"bold"}>
          {value}
        </Text>
        <Flex flexGrow={1} />
        <Text fontSize={["sm", "md"]} lineHeight={1.35}>
          <APFormattedMessage id={translationId} values={{ nl: "", ...translationValues }} />
        </Text>
      </Flex>
    </GridItem>
  )
}